import { BookingsManager } from '@/components/dashboard/BookingsManager';

export default function HostBookings() {
  return <BookingsManager />;
}
